import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ActionsIcon = createIcon(
  'Actions',
  <path d="M10.1326019,21.3846154 L10.1326019,21.3846154 C9.64285221,21.3846154 9.26504532,21.0507692 9.33500956,20.6738462 L10.5943658,13.8461538 L5.69686916,13.8461538 C4.46549857,13.8461538 5.23510519,13.0384615 5.26309088,13.0061538 C7.02618969,10.6046154 9.6708379,7.05076923 13.1690498,2.31230769 C13.3089783,2.11846154 13.5888353,2 13.8686922,2 L13.8686922,2 C14.3584419,2 14.7362488,2.33384615 14.6662845,2.71076923 L13.4069282,9.53846154 L18.3184178,9.53846154 C18.8781317,9.53846154 19.1859743,9.74307692 18.8781317,10.2492308 C14.2744848,16.4307692 11.6018509,20.0384615 10.8322443,21.0723077 C10.6923158,21.2661538 10.4264517,21.3846154 10.1326019,21.3846154 Z" />
);

export default ActionsIcon;
